/**
 * RIFTBOUND TCG - Complete Game Configuration
 *
 * This is the ONLY file you need to modify for Riftbound-specific settings.
 * Everything about the game is configured here.
 */

import { RBHandler } from "./handler";
import {
  getCardData,
  getAACardIdData,
  getCardImage,
  getAAFromCardId,
} from "@/lib/games/riftbound/getCardDataLocal";
import { GAME_DOMAINS } from "@/games/domains";

export const riftboundGame = {
  // ============================================================================
  // BASIC INFO
  // ============================================================================
  id: "riftbound" as const,
  name: "Riftbound TCG",
  abbreviation: "RB TCG",
  gameId: 3, // Database game ID

  // ============================================================================
  // SEO & METADATA
  // ============================================================================
  seo: {
    title: "Riftbound TCG Meta Decklists & Card DB",
    description:
      "Explore Riftbound TCG – the League of Legends card game – with TCGfan. Browse top meta decklists, a complete card database, and the latest strategies featuring iconic champions from the League universe. Whether you're climbing the ranks or building your first deck, find everything you need to master Riftbound TCG right here.",
  },

  // ============================================================================
  // GAME MECHANICS
  // ============================================================================
  mechanics: {
    hasLeader: false,
    hasLeaderDistribution: false,
    hasPieChart: false,
    hasFormatReleaseDates: false,
    maxCopiesDefault: 4,
    hasLifeProperty: false,
    leaderType: "Legend",
  },

  tcgplayer: {
    categoryId: 89,
    productLine: "Riftbound: League of Legends Trading Card Game",
  },

  routePrefix: "riftbound/",

  // ============================================================================
  // FORMATS & SETS
  // ============================================================================
  formats: {
    east: ["OGN"],
  },

  /** Public decklist-submission form, if the game accepts submissions. */
  submitFormUrl: undefined as string | undefined,

  // ============================================================================
  // NAVIGATION & UI
  // ============================================================================
  navigation: {
    /** The game's deck builder, or undefined if it has none yet. */
    deckbuilderHref: undefined as string | undefined,
    showMarketWatch: true,
    marketWatchHref: "/riftbound/market-watch",
    showTools: false,
    showBoosters: false,
    showStarters: false,
    showSearch: false,
  },

  // ============================================================================
  // DOMAIN CONFIGURATION
  // ============================================================================
  domain: {
    ...GAME_DOMAINS["riftbound"],
    disabledRoutes: [] as string[],
  },

  // ============================================================================
  // GAME HANDLER & DECK BUILDER
  // ============================================================================
  handler: () => new RBHandler(),

  deckBuilder: {
    getCardData,
    getAACardIdData,
    getCardImage,
    getAAFromCardId,
  },

  // ============================================================================
  // CDN CONFIGURATION
  // ============================================================================
  cdn: {
    // Riftbound doesn't use leader squares currently
    leaderSquaresPath: undefined,
  } as { leaderSquaresPath?: string },

  // ============================================================================
  // INITIAL STATE FOR STORES (auto-generated, no need to modify)
  // ============================================================================
  initialState: {
    prices: null,
    loading: false,
    decks: [],
    cardOrderIds: [],
    filters: {},
  },
};

export type RiftboundGame = typeof riftboundGame;
